import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Images } from '../../../../../../shared/app-constants';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import { supportUrls } from '../../../../../../shared/utils/urls';
import { AnalyticsEvents } from '../../../../../../shared/enums/analytics';
import {
  getUserPlanName,
  getUserRole,
  getUserShAccountId,
  getUserTrackingId,
} from '../../../../../../shared/utils/user-details';

const JoinSlackCommunityTooltip = (popoverText) => (
  <Tooltip id="popover-basic" className="bs-tooltip-inner">
    {popoverText}
  </Tooltip>
);

const JoinSlackCommunity = () => {
  const { t } = useTranslation();

  const handleJoinClick = () => {
    window?.analytics?.track?.({
      userId: getUserTrackingId(),
      event: AnalyticsEvents.TriedJoiningSlackCommunity,
      properties: {
        shAccountId: getUserShAccountId(),
        role: getUserRole(),
        current_plan: getUserPlanName(),
      },
    });

    window.open(supportUrls.slackCommunityURL, '_blank');
  };

  return (
    <OverlayTrigger
      overlay={JoinSlackCommunityTooltip(t('labels.joinSlackCommunity'))}
      placement="bottom"
    >
      <div
        style={{ cursor: 'pointer' }}
        className="d-flex hover-on-join-community"
        {...accessibleOnClick(handleJoinClick)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" id="slack">
          <g fill="none" fillRule="evenodd">
            <path
              fill="#36C5F0"
              d="M19.712.133a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386h5.376V5.52A5.381 5.381 0 0 0 19.712.133m0 14.365H5.376A5.381 5.381 0 0 0 0 19.884a5.381 5.381 0 0 0 5.376 5.387h14.336a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386"
            />
            <path
              fill="#2EB67D"
              d="M53.76 19.884a5.381 5.381 0 0 0-5.376-5.386 5.381 5.381 0 0 0-5.376 5.386v5.387h5.376a5.381 5.381 0 0 0 5.376-5.387m-14.336 0V5.52A5.381 5.381 0 0 0 34.048.133a5.381 5.381 0 0 0-5.376 5.387v14.364a5.381 5.381 0 0 0 5.376 5.387 5.381 5.381 0 0 0 5.376-5.387"
            />
            <path
              fill="#ECB22E"
              d="M34.048 54a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386h-5.376v5.386A5.381 5.381 0 0 0 34.048 54m0-14.365h14.336a5.381 5.381 0 0 0 5.376-5.386 5.381 5.381 0 0 0-5.376-5.387H34.048a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386"
            />
            <path
              fill="#E01E5A"
              d="M0 34.249a5.381 5.381 0 0 0 5.376 5.386 5.381 5.381 0 0 0 5.376-5.386v-5.387H5.376A5.381 5.381 0 0 0 0 34.25m14.336-.001v14.364A5.381 5.381 0 0 0 19.712 54a5.381 5.381 0 0 0 5.376-5.387V34.25a5.381 5.381 0 0 0-5.376-5.387 5.381 5.381 0 0 0-5.376 5.387"
            />
          </g>
        </svg>
      </div>
    </OverlayTrigger>
  );
};

export default JoinSlackCommunity;
